import React, { ReactNode } from 'react';

import classes from './WidgetTitle.module.scss';
import { InfoTooltip } from '../../../../shared/components/ui-components';

type WidgetTitleProps = {
  title: string;
  tooltipContent: ReactNode;
  endAdornment?: ReactNode;
};

const WidgetTitle = ({ title, tooltipContent, endAdornment }: WidgetTitleProps) => {
  return (
    <div className={classes.container}>
      <div className={classes.titleBlock}>
        <h3 className={classes.title}>{title}</h3>
        <InfoTooltip arrow placement="right">
          {tooltipContent}
        </InfoTooltip>
      </div>
      {endAdornment}
    </div>
  );
};

export { WidgetTitle };
